import { useState } from "react";
import { DatePicker, Button, Space, Typography, Tag, Badge, Tooltip } from "antd";
import { CalendarOutlined, BellTwoTone, FileSearchOutlined, ReloadOutlined } from "@ant-design/icons";
import moment from "moment";
import "./journalHeader.scss";

const { RangePicker } = DatePicker;
const { Title, Text } = Typography;

const JournalHeader = ({ title, onPeriodChange, alertCount = 0 }) => {
  const today = moment();
  const [dates, setDates] = useState([today.clone().startOf("month"), today]);

  const handleChange = (dates) => setDates(dates);

  const handleGenerate = () => {
    if (dates?.length === 2 && onPeriodChange) {
      onPeriodChange([
        dates[0].format("YYYY-MM-DD"),
        dates[1].format("YYYY-MM-DD"),
      ]);
    }
  };

  return (
    <header className="rapport-header">
      <div className="rapport-header__content">
        <div className="rapport-header__title-section">
            <div>
                <div style={{display:"flex", alignItems:'center', gap:'10px'}}>
                    <FileSearchOutlined className="rapport-header__icon" />
                    <div>
                    <Title level={3} className="rapport-header__title">
                      {title}
                    </Title>
                    <Text type="secondary" className="rapport-header__subtitle">
                      Suivi, analyse et performance générale
                    </Text>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </header>
  );
};

export default JournalHeader;
